import { render, staticRenderFns } from "./termsofuse.vue?vue&type=template&id=7cb7a0a4&"
import script from "./termsofuse.vue?vue&type=script&lang=js&"
export * from "./termsofuse.vue?vue&type=script&lang=js&"
import style0 from "./termsofuse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports